export const PARAMS_NAME = {
    onwRevenue: 'ONW Revenue',
    totalRevenue: 'Total Revenue',
    invalidConversions: 'Invalid Conversions',
    cpc: 'Avg. CPC',
    vClicks: 'Voluum Clicks',
    winRate: 'Won %',
    ctr: 'CTR',
    clickDisc: 'Click Disc %',
    roiPercent: 'ROI %',
    roi: 'ROI'
};
export const NAN_PARAMS = {
    date: 1,
    affid: 1,
    subid: 1,
    country: 1
};


// WEBPACK FOOTER //
// ./src/scenes/PushapiV3/config.js